import { CreateForm, FormFieldsData } from 'framework/form';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import { useProjectId } from 'domain/shared/project';
import { useProjectDataContext } from 'domain/shared/newProject';
import useProjectReviewService from '../useProjectReviewService';
import { ProjectReviewPeriodInfo, ProjectReviewResult } from '../types';
import ProjectReviewForm from './ProjectReviewForm';
import {
  getProjectReviewFormData,
  getProjectReviewFormDataAfterStart,
  getProjectReviewPeriod,
} from './projectReviewFormData';

interface ProjectReviewConfigurationProps {
  hasCurrentReview: boolean;
  latestProjectReview: ProjectReviewPeriodInfo;
  onReviewStarted: (projectReview: ProjectReviewResult) => void;
}

const ProjectReviewConfiguration = ({
  hasCurrentReview,
  latestProjectReview,
  onReviewStarted,
}: ProjectReviewConfigurationProps) => {
  const { getToday } = useDateService();
  const projectId = useProjectId();
  const { startProjectReview } = useProjectReviewService();
  const { data: project } = useProjectDataContext();
  const currentReviewDate = getToday().format(DATE_FORMAT.API_ONLY_DATE);

  const submitFormFunc = async (data: FormFieldsData) => ({
    result: await startProjectReview(projectId, getProjectReviewPeriod(data)),
  });

  return (
    <CreateForm
      initialData={getProjectReviewFormData(latestProjectReview, currentReviewDate)}
      submitFormFunc={submitFormFunc}
      afterSubmit={{
        execute: response => onReviewStarted(response.result),
        resetData: response => getProjectReviewFormDataAfterStart(response.result),
      }}
      handleDirty={false}
    >
      <ProjectReviewForm
        previousReviewDate={latestProjectReview.lastReviewEndDate ?? undefined}
        hasReview={hasCurrentReview}
        projectStartDate={project.budget?.startDate}
        projectEndDate={project.budget?.endDate}
      />
    </CreateForm>
  );
};

export default ProjectReviewConfiguration;
